import { IPreAuthenticationRequest } from '../../model/security/request/pre-authentication-request';
import { IAuthenticationRequest } from '../../model/security/request/authentication-request';
import { ValidationErrors, isBlank, isEmptyId } from '../../utils/validation';

export type LoginField = 'type' | 'user' | 'password' | 'companyId';

// Etapa 1: tipo de login e credenciais
export function validateCredentials(request: Partial<IPreAuthenticationRequest>): ValidationErrors<LoginField> {
    const errors: ValidationErrors<LoginField> = {};
    if (isEmptyId(request.type)) errors.type = 'Selecione o tipo de login';
    if (isBlank(request.user)) errors.user = 'Informe o e-mail ou usuário';
    if (isBlank(request.password)) errors.password = 'Informe a senha';
    return errors;
}

// Etapa 2: além das credenciais, a entidade/empresa escolhida
export function validateAuthentication(request: Partial<IAuthenticationRequest>): ValidationErrors<LoginField> {
    const errors = validateCredentials(request);
    if (isEmptyId(request.companyId)) errors.companyId = request.type === 1 ? 'Selecione a entidade' : 'Selecione a empresa';
    return errors;
}
